import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';

export default function NotFoundPage() {
  return (
    <Layout>
      <section style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F9F6EF' }}>
        <div style={{ textAlign: 'center', padding: '0 24px' }}>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(6rem, 20vw, 14rem)', fontWeight: 800, color: '#B8860B', lineHeight: 1 }}>
            404
          </h1>
          <h2 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1.2rem', fontWeight: 700, letterSpacing: '0.12em', color: '#0A1628', marginBottom: '1rem', textTransform: 'uppercase' }}>
            Page Not Found
          </h2>
          <p style={{ color: '#6B7E94', marginBottom: '2rem', maxWidth: '420px', margin: '0 auto 2rem', lineHeight: 1.7 }}>
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <Link
            to="/"
            style={{ display: 'inline-block', padding: '0.875rem 2rem', background: '#0A1628', color: '#F9F6EF', fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', transition: 'opacity 0.2s' }}
          >
            Back to Home
          </Link>
        </div>
      </section>
    </Layout>
  );
}
